(function () {
  'use strict';

  var GALLERY_SELECTOR = '[data-bd-variant-media-gallery]';
  var VARIANT_SELECT_SELECTOR = '[data-ml-variant-select]';

  function toVariantToken(variantId) {
    return '|' + String(variantId || '') + '|';
  }

  function isHidden(element) {
    return !element || element.hidden;
  }

  function asArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function getGalleryItem(element) {
    if (!element) return null;
    if (element.matches && element.matches('[data-bd-gallery-item]')) return element;
    return element.closest ? element.closest('[data-bd-gallery-item]') : element;
  }

  function parseInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  function getMediaSequence(element) {
    var item = getGalleryItem(element);
    return parseInteger(item && item.getAttribute('data-bd-media-sequence'), 0);
  }

  function getGalleryOrder(element) {
    var item = getGalleryItem(element);
    if (!item) return 0;
    return parseInteger(item.getAttribute('data-bd-gallery-order'), getMediaSequence(item));
  }

  function sortByGalleryOrder(items) {
    return asArray(items).sort(function (a, b) {
      var orderDiff = getGalleryOrder(a) - getGalleryOrder(b);
      if (orderDiff !== 0) return orderDiff;
      return getMediaSequence(a) - getMediaSequence(b);
    });
  }

  function getVisibleSlides(gallery) {
    var viewer = gallery && gallery.elements ? gallery.elements.viewer : null;
    var scope = viewer || gallery;
    if (!scope) return [];

    return sortByGalleryOrder(
      asArray(scope.querySelectorAll('[data-media-id]')).filter(function (element) {
        return !isHidden(element);
      })
    );
  }

  function getVisibleThumbnailButtons(gallery) {
    var thumbnails = gallery && gallery.elements ? gallery.elements.thumbnails : null;
    if (!thumbnails) return [];

    return sortByGalleryOrder(
      asArray(thumbnails.querySelectorAll('[data-target] button')).filter(function (button) {
        var thumbnail = button.closest('[data-target]');
        return thumbnail && !isHidden(thumbnail);
      })
    );
  }

  function getVisibleThumbnails(gallery) {
    var thumbnails = gallery && gallery.elements ? gallery.elements.thumbnails : null;
    if (!thumbnails) return [];

    return sortByGalleryOrder(
      asArray(thumbnails.querySelectorAll('[data-target]')).filter(function (thumbnail) {
        return !isHidden(thumbnail);
      })
    );
  }

  function patchMediaGallery(gallery) {
    if (!gallery || gallery.__bdVariantMediaPatched) return;

    gallery.__bdVariantMediaPatched = true;

    gallery.mediaSlides = function () {
      return getVisibleSlides(this);
    };

    gallery.getThumbnailButtons = function () {
      return getVisibleThumbnailButtons(this);
    };

    gallery.jumpToIndex = function (position) {
      if (!this.elements || !this.elements.viewer) return;

      var slides = this.mediaSlides();
      if (!slides.length) return;

      var target = position === -1 ? slides[slides.length - 1] : slides[Math.max(0, position)];
      if (!target) return;

      var mediaId = target.dataset.mediaId || target.getAttribute('data-media-id');
      if (mediaId && typeof this.setActiveMedia === 'function') this.setActiveMedia(mediaId, false);
    };
  }

  function getSelectedVariantId(root) {
    if (!root) return '';

    var select = root.querySelector(VARIANT_SELECT_SELECTOR);
    if (select && select.value) return String(select.value);

    var productFormInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
    if (productFormInput && productFormInput.value) return String(productFormInput.value);

    return '';
  }

  function itemMatchesVariant(item, variantId) {
    if (!item || !variantId) return false;
    var ids = item.getAttribute('data-bd-variant-ids') || '';
    return ids.indexOf(toVariantToken(variantId)) !== -1;
  }

  function isMainMediaItem(item) {
    return !!item && item.getAttribute('data-bd-main-media') === 'true';
  }

  function isSharedMediaItem(item) {
    return !!item && item.getAttribute('data-bd-shared-media') === 'true';
  }

  function hasSelectedVariantGroup(gallery, variantId) {
    if (!gallery || !variantId) return false;

    var items = gallery.querySelectorAll('[data-bd-gallery-item]');
    for (var i = 0; i < items.length; i += 1) {
      if (!isMainMediaItem(items[i]) && itemMatchesVariant(items[i], variantId)) return true;
    }

    return false;
  }

  function setItemVisibility(item, shouldShow) {
    if (!item) return;

    if (shouldShow) {
      item.hidden = false;
      item.removeAttribute('aria-hidden');
    } else {
      item.hidden = true;
      item.setAttribute('aria-hidden', 'true');
    }
  }

  function setGalleryOrder(item, order) {
    if (!item) return;
    var normalizedOrder = parseInteger(order, getMediaSequence(item));
    item.setAttribute('data-bd-gallery-order', String(normalizedOrder));
    if (item.style && item.style.setProperty) {
      item.style.setProperty('--bd-gallery-order', String(normalizedOrder));
    }
  }

  function calculateGalleryOrder(item, variantId, shouldFilter) {
    var sequence = getMediaSequence(item);

    if (isMainMediaItem(item)) return 30000 + sequence;
    if (isSharedMediaItem(item)) return 10000 + sequence;
    if (shouldFilter && !itemMatchesVariant(item, variantId)) return 20000 + sequence;

    return sequence;
  }

  function reorderContainerByGalleryOrder(container, selector) {
    if (!container) return;

    var items = sortByGalleryOrder(container.querySelectorAll(selector));
    for (var i = 0; i < items.length; i += 1) {
      container.appendChild(items[i]);
    }
  }

  function reorderGalleryDom(gallery) {
    if (!gallery) return;

    var viewerList = gallery.querySelector('[id^="Slider-Gallery"]');
    var thumbnailList = gallery.querySelector('[id^="Slider-Thumbnails"]');

    reorderContainerByGalleryOrder(viewerList, '[data-media-id]');
    reorderContainerByGalleryOrder(thumbnailList, '[data-target]');
  }

  function revealAll(gallery, includeMainMedia) {
    var items = gallery.querySelectorAll('[data-bd-gallery-item], [data-bd-variant-ids], [data-media-id], [data-target]');
    for (var i = 0; i < items.length; i += 1) {
      var item = getGalleryItem(items[i]) || items[i];
      setGalleryOrder(item, calculateGalleryOrder(item, '', false));
      setItemVisibility(item, includeMainMedia || !isMainMediaItem(item));
    }
    reorderGalleryDom(gallery);
  }

  function findThumbnailByMediaId(gallery, mediaId) {
    var thumbnails = gallery && gallery.elements ? gallery.elements.thumbnails : null;
    if (!thumbnails || !mediaId) return null;

    var items = sortByGalleryOrder(thumbnails.querySelectorAll('[data-target]'));
    for (var i = 0; i < items.length; i += 1) {
      if (!isHidden(items[i]) && items[i].getAttribute('data-target') === mediaId) return items[i];
    }

    return null;
  }

  function resetSlider(sliderComponent, activeItem) {
    if (!sliderComponent) return;

    if (typeof sliderComponent.resetPages === 'function') {
      sliderComponent.resetPages();
    }

    if (sliderComponent.slider && activeItem) {
      sliderComponent.slider.scrollTo({ left: activeItem.offsetLeft || 0 });
    }
  }

  function activateVisibleMedia(gallery, activeSlide) {
    if (!gallery || !activeSlide) return;

    var mediaId = activeSlide.dataset.mediaId || activeSlide.getAttribute('data-media-id');
    var allSlides = gallery.querySelectorAll('[data-media-id]');
    for (var i = 0; i < allSlides.length; i += 1) {
      allSlides[i].classList.toggle('is-active', allSlides[i] === activeSlide);
    }

    var thumbnail = findThumbnailByMediaId(gallery, mediaId);
    var thumbnailButtons = gallery.querySelectorAll('[data-target] button');
    for (var j = 0; j < thumbnailButtons.length; j += 1) {
      thumbnailButtons[j].removeAttribute('aria-current');
    }

    if (thumbnail) {
      var button = thumbnail.querySelector('button');
      if (button) button.setAttribute('aria-current', 'true');
    }

    resetSlider(gallery.elements && gallery.elements.viewer, activeSlide);
    resetSlider(gallery.elements && gallery.elements.thumbnails, thumbnail);

    if (typeof gallery.playActiveMedia === 'function') gallery.playActiveMedia(activeSlide);
  }

  function syncNavigation(gallery, visibleSlideCount, visibleThumbnailCount) {
    if (!gallery) return;

    if (gallery.viewerNav) {
      gallery.viewerNav.hidden = visibleSlideCount <= 1;
    }

    if (gallery.elements && gallery.elements.thumbnails) {
      gallery.elements.thumbnails.hidden = visibleThumbnailCount <= 1;
      gallery.elements.thumbnails.classList.toggle('thumbnail-slider--no-slide', visibleThumbnailCount <= 3);
    }

    if (typeof gallery.updateNavigationState === 'function') {
      gallery.updateNavigationState(0, visibleSlideCount);
    }
  }

  function filterGalleryForVariant(gallery, variantId) {
    if (!gallery) return;

    patchMediaGallery(gallery);

    var hasVariantGroups = gallery.getAttribute('data-bd-has-variant-groups') === 'true';
    var shouldFilter = hasVariantGroups && variantId && hasSelectedVariantGroup(gallery, variantId);
    var filterableItems = gallery.querySelectorAll('[data-bd-gallery-item]');

    for (var i = 0; i < filterableItems.length; i += 1) {
      var item = filterableItems[i];
      var shouldShow = !isMainMediaItem(item) && (isSharedMediaItem(item) || !shouldFilter || itemMatchesVariant(item, variantId));

      setGalleryOrder(item, calculateGalleryOrder(item, variantId, shouldFilter));
      setItemVisibility(item, shouldShow);
    }

    reorderGalleryDom(gallery);

    var visibleSlides = getVisibleSlides(gallery);
    var visibleThumbnails = getVisibleThumbnails(gallery);

    if (!visibleSlides.length) {
      revealAll(gallery, false);
      visibleSlides = getVisibleSlides(gallery);
      visibleThumbnails = getVisibleThumbnails(gallery);
    }

    if (!visibleSlides.length) {
      revealAll(gallery, true);
      visibleSlides = getVisibleSlides(gallery);
      visibleThumbnails = getVisibleThumbnails(gallery);
    }

    var preferredSlide = null;
    for (var j = 0; j < visibleSlides.length; j += 1) {
      if (visibleSlides[j].getAttribute('data-bd-variant-marker') === 'true' && itemMatchesVariant(visibleSlides[j], variantId)) {
        preferredSlide = visibleSlides[j];
        break;
      }
    }

    activateVisibleMedia(gallery, preferredSlide || visibleSlides[0]);
    syncNavigation(gallery, visibleSlides.length, visibleThumbnails.length);
    gallery.setAttribute('data-bd-selected-variant-id', variantId || '');
  }

  function initGallery(gallery) {
    if (!gallery) return;

    var root = gallery.closest('[id^="ProductsOne-"]') || gallery.closest('.shopify-section') || document;
    patchMediaGallery(gallery);

    function update() {
      filterGalleryForVariant(gallery, getSelectedVariantId(root));
    }

    gallery.__bdVariantMediaUpdate = update;

    if (!gallery.__bdVariantMediaInitialized) {
      gallery.__bdVariantMediaInitialized = true;

      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches && event.target.matches(VARIANT_SELECT_SELECTOR)) {
          update();
        }
      });

      document.addEventListener('shopify:section:load', function (event) {
        if (event.target && event.target.contains(gallery)) update();
      });
    }

    update();
  }

  function initAll(scope) {
    var root = scope || document;
    var galleries = root.querySelectorAll(GALLERY_SELECTOR);
    for (var i = 0; i < galleries.length; i += 1) {
      initGallery(galleries[i]);
    }
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  onReady(function () {
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('media-gallery').then(function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
  });
})();
